import React, { memo } from 'react';
import { string, number } from 'prop-types';
import { LogoMagalu } from '@magalu/stereo-ui-icons';
import LogoParceiroMagalu from '../LogoParceiroMagalu';

const Logo = ({
  storeName,
  width,
  height,
  src,
  alt,
  prefix
}) => {
  if (storeName) {
    return /*#__PURE__*/React.createElement(LogoParceiroMagalu, {
      name: storeName,
      prefix: prefix
    });
  }

  if (src) {
    return /*#__PURE__*/React.createElement("img", {
      id: "logo",
      width: `${width}px`,
      src: src,
      alt: alt
    });
  }

  return /*#__PURE__*/React.createElement(LogoMagalu, {
    id: "logo",
    color: "#fff",
    width: width,
    height: height,
    viewBox: "0 0 60 13",
    titleAccess: "Logo Magalu"
  });
};

Logo.defaultProps = {
  storeName: undefined,
  prefix: undefined,
  width: 87,
  height: 19,
  src: '',
  alt: ''
};
process.env.NODE_ENV !== "production" ? Logo.propTypes = {
  storeName: string,
  prefix: string,
  width: number,
  height: number,
  src: string,
  alt: string
} : void 0;
export default /*#__PURE__*/memo(Logo);